import React from "react";
import { Icon } from "@bookingcom/bui-react";
import FlightDetailsAncillaryItemLayout from "../../../../../FlightDetailsAncillaryItemLayout";
import useExtraProductsInfo2Controller from "./ExtraProductsInfo2.controller";
import { BagHoldNotAvailableIcon } from "@bookingcom/bui-assets-react/streamline";
import { UIFlightData } from "@flights/types";
import useRouteName from "../../../../../../../hooks/useRouteName";
import useProfiler from "../../../../../../../hooks/useProfiler";
import flights_web_condensed_extras_fd_mdot from "../../../../../../../utils/experiments/funnel/flights_web_condensed_extras_fd_mdot";

const useExtraProductsInfo2 = (flight: UIFlightData) => {
  const { header, baggageText } = useExtraProductsInfo2Controller(flight);

  const routeName = useRouteName();
  const { isMobile } = useProfiler();
  const condensedFDMobile =
    routeName == "flightdetails" && isMobile() && !!flights_web_condensed_extras_fd_mdot.trackWithDefaultStage();

  if (!baggageText) return undefined;

  return {
    header,
    content: (
      <FlightDetailsAncillaryItemLayout
        icon={<Icon size={condensedFDMobile ? "medium" : "large"} svg={BagHoldNotAvailableIcon} />}
        content={<div dangerouslySetInnerHTML={{ __html: baggageText }}></div>}
        hideIncludedSection={true}
      />
    )
  };
};

export default useExtraProductsInfo2;
